module.exports = __webpack_public_path__ + "static/media/pen.fc0fc6fc.svg";